






























import { Component, Prop, Vue } from 'vue-property-decorator';
import Avatar from '@/components/Avatar.vue';
import {
  ChannelMessageFields,
  SenderFields
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    Avatar
  }
})
export default class Message extends Vue {
  @Prop({ required: true, type: Object }) message!: ChannelMessageFields;
  @Prop({ default: false, type: Boolean }) isSender!: boolean;
  @Prop({ default: true, type: Boolean }) showAvatar!: boolean;

  getAvatarUrl(sender: SenderFields) {
    return sender.avatar && sender.avatar.url;
  }
}
